import { useSelector } from "react-redux"
import { selectCommentId, selectCurrentConfirmTypeModal, selectCurrentId, selectCurrentProposalId, selectCurrentTypeModal, selectCurrentTypeOfProposalStatus, selectCurrentTypeOfStatus, selectCurrentUpdateTypeModal, selectIsPrototype, selectTypeOfRates, selectTypeOfUserView } from "../../../features/gms-state-and-modal/modal-slice"

export const useModalAccess = () => {
    
    const currentProposalId = useSelector(selectCurrentProposalId);
    const currentUserId = useSelector(selectCurrentId);
    const commentId = useSelector(selectCommentId);
    const currentTypeOfProposal = useSelector(selectCurrentTypeOfProposalStatus);
    const isPrototype = useSelector(selectIsPrototype);

    const modalUpdate = useSelector(selectCurrentUpdateTypeModal);
    const isUpdateProposal = modalUpdate === 'updateProposal';
    const isSubmitAsDraftProposal = modalUpdate === "submitAsDraftProposal";
    const isShowAuthUpdateModal = modalUpdate === "showAuthUpdateModal";
    const isUpdateProposalComputation = modalUpdate === "updateProposalComputation";
    const isShowProposalDetails = modalUpdate === "showProposalDetails";
    const isShowUpdateStatusGMSProposal = modalUpdate === "showUpdateStatusGMSProposal";
    const isShowComputationDetails = modalUpdate === "showComputationDetails";
    
    const modalType = useSelector(selectCurrentTypeModal);
    const isVerifyOTPModal = modalType === "verifyOTPModal";
    const isViewUser = modalType === "viewUser";
    const isShowRates = modalType === "showRates";
    const isShowIndustries = modalType === "showIndustries";
    const isShowActionProposalModal = modalType === "showActionProposalModal";
    const isShowActionProposalExtension = modalType === "showActionProposalExtension";

    const confirmModal = useSelector(selectCurrentConfirmTypeModal);
    const isResetPassword = confirmModal === "isResetPassword";
    const isActivate = confirmModal === "isActivate";
    const isUpdateEmpProfile = confirmModal === "isUpdateEmpProfile";
    const isCancelUpdateMessage = confirmModal === "isCancelUpdateMessage";
    const isDeleteMessage = confirmModal === "deleteMessage";
    const isConfirmBookedProposal = confirmModal === "isConfirmBookedProposal";
    const isConfirmMissingTinAndSec = confirmModal === "isMissingTinAndSec";
    const isConfirmReleaseProposal = confirmModal === "isConfirmReleaseProposal";

    const typeOfStatus = useSelector(selectCurrentTypeOfStatus);
    const isStatusActive = typeOfStatus === 'activate';
    const isStatusDeactive = typeOfStatus === 'deactivate';

    const typeOfRates = useSelector(selectTypeOfRates);
    const isRates0065 = typeOfRates === '0065'
    const isRates1865 = typeOfRates === '1865'
    const isRates6670 = typeOfRates === '6670'
    const isRates7175 = typeOfRates === '7175'
    const isRates7680 = typeOfRates === '7680'

    const typeOfUserView = useSelector(selectTypeOfUserView);
    const isMRK_GM_RH = typeOfUserView === 'MRK_GMS_RH'

    return {
        currentProposalId,
        currentUserId,
        commentId,
        currentTypeOfProposal,
        isPrototype,

        modalUpdate,
        isUpdateProposal,
        isSubmitAsDraftProposal,
        isShowAuthUpdateModal,
        isUpdateProposalComputation,
        isShowProposalDetails,
        isShowUpdateStatusGMSProposal,
        isShowComputationDetails,

        modalType,
        isVerifyOTPModal,
        isViewUser,
        isShowRates,
        isShowIndustries,
        isShowActionProposalModal,
        isShowActionProposalExtension,

        confirmModal,
        isResetPassword,
        isActivate,
        isUpdateEmpProfile,
        isCancelUpdateMessage,
        isDeleteMessage,
        isConfirmBookedProposal,
        isConfirmMissingTinAndSec,
        isConfirmReleaseProposal,

        typeOfStatus,
        isStatusActive,
        isStatusDeactive,

        typeOfRates,
        isRates0065,
        isRates1865,
        isRates6670,
        isRates7175,
        isRates7680,

        typeOfUserView,
        isMRK_GM_RH,
    }
}